<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear / Editar -->
    <v-dialog
      max-width="65%"
      v-model="dialogAddEdit"
      persistent
    >
      <v-card>
        <v-card-title>
          {{ editedItem.id_expediente_requisito === null ? "Crear" : "Editar" }} Requisito de Expediente
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="editedItem.tipo_documento"
                label="Tipo de Requisito"
                :items="tipos_documentos"
                item-value="value"
                item-text="text"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editedItem.nota"
                label="Nota (opcional)"
                outlined
                dense
                hide-details
                rows="2"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog
      max-width="65%"
      v-model="dialogDelete"
      persistent
    >
      <v-card>
        <v-card-title>
          Eliminar Requisito de Expediente
        </v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el requisito llamado "{{ editedItem.nombre }}"?
          Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón Crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Requisito de Expediente
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.nombre`]="{ item }">
          <div>
            <div>{{ item.nombre }}</div>
            <div v-if="item.nota != null && item.nota.length > 0" class="text-caption" style="opacity: 0.7;">
              Nota: {{ item.nota }}
            </div>
          </div>
        </template>

          <template v-slot:[`item.tipo_documento`]="{ item }">
            {{ obtenerTipoDocumento(item.tipo_documento) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogAddEdit(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="openDialogDelete(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    dialogAddEdit: false,
    loading: false,
    items: [],
    headers: [
      {
        text: "Nombre",
        value: "nombre",
        align: "left",
        width: "45%"
      },
      {
        text: "Tipo Documento",
        value: "tipo_documento",
        align: "center",
        width: "20%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],
    editedItem: {
      id_expediente_requisito: null,
      nombre: "",
      tipo_documento: null,
      nota: ""
    },
    defaultEditedItem: {
      id_expediente_requisito: null,
      nombre: "",
      tipo_documento: null,
      nota: ""
    },
    loadingSave: false,
    dialogDelete: false,
    loadingDelete: false,
    tipos_documentos: [
      { value: 1, text: "Archivo" },
      { value: 2, text: "Texto Libre" },
      { value: 3, text: "Número de Teléfono" }
    ]
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      axios
        .get('/RecursosHumanos/ListarExpedienteRequisitos')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = true;
    },
    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    saveDialogAddEdit() {
      // Validaciones
      if (!this.editedItem.nombre || this.editedItem.nombre.length === 0 || this.editedItem.nombre.length > 512) {
        this.$refs.alert.setMessage("", "Debe ingresar un Nombre entre 1 y 512 caracteres.");
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.tipo_documento === null || this.editedItem.tipo_documento === "" || isNaN(this.editedItem.tipo_documento)) {
        this.$refs.alert.setMessage("", "Debe ingresar un Tipo de Documento válido.");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      axios({
        method: this.editedItem.id_expediente_requisito === null ? 'POST' : 'PUT',
        url:
          this.editedItem.id_expediente_requisito === null
            ? '/RecursosHumanos/CrearExpedienteRequisito'
            : `/RecursosHumanos/EditarExpedienteRequisito/${this.editedItem.id_expediente_requisito}`,
        data: {
          nombre: this.editedItem.nombre,
          tipo_documento: Number(this.editedItem.tipo_documento),
          nota: this.editedItem.nota
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch(error => {
          if (error.response && error.response.status === 409) {
            this.$refs.alert.setMessage("", "Existe un Requisito de Expediente con el mismo Código.");
            this.$refs.alert.open();
            return;
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
    saveDialogDelete() {
      this.loadingDelete = true;
      axios
        .delete(`/RecursosHumanos/EliminarExpedienteRequisito/${this.editedItem.id_expediente_requisito}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    obtenerTipoDocumento(tipo_documento){
      var tp = this.tipos_documentos.find(x => x.value == tipo_documento);
      if(tp != null) return tp.text;
      else return '';
    }
  }
}
</script>
